import { useState } from "react";
import { portalAuthErrorMessage } from "../auth/errors";
import { claimInvitation } from "../auth/passkeys";
import type { PortalMeDto } from "../model";
import { StatusBanner } from "./StatusBanner";
export function InvitationView({ onAuthenticated }: { onAuthenticated: (actor: PortalMeDto) => void }) {
	const [code, setCode] = useState("");
	const [error, setError] = useState("");
	const [submitting, setSubmitting] = useState(false);
	async function claim() {
		if (!code.trim() || submitting) return;
		setSubmitting(true);
		setError("");
		try {
			onAuthenticated(await claimInvitation(code.trim()));
		} catch (reason) {
			setError(portalAuthErrorMessage(reason, "The invitation is invalid, expired, or already used."));
		} finally {
			setSubmitting(false);
		}
	}
	return (
		<section className="auth-card" aria-labelledby="claim-heading">
			<p className="eyebrow">WELCOME TO THE PROJECT</p>
			<h1 id="claim-heading" tabIndex={-1}>
				Claim your invitation
			</h1>
			<p>Paste the private invitation code Neal shared with you. It is used once and never saved by this browser.</p>
			{error && <StatusBanner kind="error">{error}</StatusBanner>}
			<label htmlFor="invite-code">Invitation code</label>
			<textarea
				id="invite-code"
				value={code}
				onChange={(event) => {
					setCode(event.target.value);
					setError("");
				}}
				autoComplete="off"
			/>
			<button type="button" disabled={!code.trim() || submitting} onClick={claim}>
				{submitting ? "Creating passkey…" : "Create my passkey"}
			</button>
			<a href="/login">Back to sign in</a>
		</section>
	);
}
